module.exports = __webpack_public_path__ + "static/media/600_WAX.a8b881b8.webp";